import { render, staticRenderFns } from "./AllocateCpes.vue?vue&type=template&id=91a023a4&"
import script from "./AllocateCpes.vue?vue&type=script&lang=js&"
export * from "./AllocateCpes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports